import { FC, useCallback, useMemo, useState } from 'react'
import { Form, Input, Button, Toast } from 'antd-mobile'
import { useTranslation } from "react-i18next";
import css from './index.module.less'
import { useCountdown } from '@/hooks/useCountdown'
import { sendSmsCode } from '@/api/user'
import getVerCode from '@/utils/getVerCode'

export const SmsCodeFormItem: FC<{
  name: string,
  phone: string,
  model?: any, // 发送验证码需要的表单内容 包括：type
}> = ({ name, phone, model = {}, ...rest }) => {
  const { t } = useTranslation();
  const [leftTime, setLeftTime] = useCountdown();
  const [loading, setLoading] = useState(false)

  const disabled = useMemo(() => !phonePattern.test(phone) || leftTime > 0, [phone, leftTime]);

  const onBtnSendClick = useCallback(() => {
    const sendCode = async () => {
      let codeInfo: any = {}
      setLoading(true)
      // 先获取图形验证码
      const [vcErr, vcRes]: any = await getVerCode();

      (window as any).useCaptcha.hide()
      if (vcErr) {
        return Toast.show(`${vcErr?.msg || t('user-center.register.ver-code')}`)
      }

      codeInfo = {
        passToken: vcRes,
      }
      const res = await sendSmsCode({ ...model, phone, ...codeInfo }).finally(() => setLoading(false)).catch(err => {
        Toast.show(`${err?.msg}`)
      })
      if (res?.code === 0) {
        Toast.show(`${t('user-center.register.send-code-done')}`)
        setLeftTime(60);
      }
    }
    sendCode();
  }, [model, phone]);

  return (
    <Form.Item className={css.InputWrap} name={name} rules={rules} {...rest} extra={
      <Button className={css.BtnSend} color='primary' fill='none' disabled={disabled} onClick={onBtnSendClick} loading={loading}>
        {leftTime > 0 ? t('user-center.register.send-code-again', { times: leftTime }) : t('user-center.register.get-code')}
      </Button>
    }>
      <Input className={css.Input} placeholder={t('user-center.register.in-code')} clearable />
    </Form.Item>
  )
}


export const phonePattern = /^1\d{10}$/;
export const rules: any[] = [{ required: true }, { type: 'string' }];
